import m from 'mithril'
import type { FeedEvent } from '../../shared/types.ts'
import { api } from '../api.ts'
import { state } from '../state.ts'
import { Empty, ErrorNote, Spinner } from '../ui.ts'
import { EventCard } from './EventCard.ts'

const PAGE = 30

export const Timeline: m.ClosureComponent = () => {
  let events: FeedEvent[] = []
  let loading = false
  let done = false
  let error = ''

  const load = async () => {
    if (!state.me || loading || done) return
    loading = true
    try {
      const page = await api<FeedEvent[]>(`/api/me/timeline?limit=${PAGE}&offset=${events.length}`)
      events = events.concat(page)
      done = page.length < PAGE
      error = ''
    } catch (err) {
      error = (err as Error).message
    } finally {
      loading = false
      m.redraw()
    }
  }

  return {
    oninit: load,
    view: () => {
      if (!state.me) {
        return m('section.hero', [
          m('h1', 'Keep track of where you have eaten.'),
          m('p', 'Rate restaurants, keep lists, follow friends, and publish it all as an RSS feed.'),
          m(m.route.Link, { href: '/login', class: 'button primary' }, 'Get started'),
          m(m.route.Link, { href: '/search', class: 'button' }, 'Browse restaurants'),
        ])
      }

      if (loading && !events.length) return m(Spinner)
      if (error && !events.length) return m(ErrorNote, { text: error })
      if (!events.length) {
        return m('section.stack', [
          m(Empty, { text: 'Follow people to see their activity' }),
          m(m.route.Link, { href: '/search', class: 'button primary' }, 'Find a restaurant'),
        ])
      }

      return m('section.stack', [
        ...events.map((event) => m(EventCard, { key: event.id, event })),
        error ? m(ErrorNote, { text: error }) : null,
        done
          ? null
          : m('button.button', { type: 'button', disabled: loading, onclick: load }, loading ? 'Loading...' : 'Load more'),
      ])
    },
  }
}
